<template>
  <v-card class="elevation-0 ma-8 pb-6 px-8">
    <v-row class="ma-0 pb-4">

      <v-card-title class="pt-0 mt-0">
        Reporte de Compras por
        <v-select outlined class="pt-6 ml-2" style="max-width:150px" dense v-model="type" :items="['Proveedor', 'Producto']"></v-select> 
      </v-card-title>
      <v-menu bottom left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="selected.length < 1 || !provider_id"
            class="mt-7 elevation-0"
            color="primary"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small>mdi-download</v-icon>
            ({{ selected.length }})
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="openPDF()">
            <v-list-item-content>
              <v-list-item-title>Descargar Orden de Compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="exportInternalExcel()">
            <v-list-item-content>
              <v-list-item-title>Descargar Reporte Interno</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        :disabled="selected.length < 1 || !provider_id"
        @click="openCreateShopping()"
        class="mt-7 ml-2 elevation-0"
        color="primary"
        small
      >
        Crear compra 
      </v-btn>
      <v-btn
        :disabled="selected.length < 1"
        @click="openSaveSelectionDialog()"
        class="mt-7 ml-2 elevation-0"
        color="secondary"
        small
      >
        <v-icon small class="mr-1">mdi-content-save</v-icon>
        Preguardar
      </v-btn>
      <v-menu bottom left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mt-7 ml-2 elevation-0"
            outlined
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small class="mr-1">mdi-folder-multiple</v-icon>
            Guardados ({{ presaved.length }})
          </v-btn>
        </template>
        <v-list dense style="min-width:360px; max-width:420px;">
          <v-list-item v-if="draftAvailable" @click="restoreDraftSelection()">
            <v-list-item-content>
              <v-list-item-title>Borrador actual</v-list-item-title>
              <v-list-item-subtitle>Recupera la selección en curso</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="selected.length" @click="clearCurrentSelection()">
            <v-list-item-content>
              <v-list-item-title>Limpiar selección actual</v-list-item-title>
              <v-list-item-subtitle>{{ selected.length }} producto(s) seleccionados</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="draftAvailable || selected.length"></v-divider>
          <v-list-item v-if="!presaved.length">
            <v-list-item-content>
              <v-list-item-title>No hay selecciones guardadas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="saved in presaved"
            :key="saved.id"
            @click="loadSavedSelection(saved.id)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ saved.label }}</v-list-item-title>
              <v-list-item-subtitle>{{ selectionSummary(saved) }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon small @click.stop="deleteSavedSelection(saved.id)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-spacer/>

      <v-autocomplete
        style="max-width:400px"
        outlined dense
        clearable
        v-model="provider_id"
        :items="providers"
        label="Proveedor"
        item-text="name"
        item-value="id"
        class="mt-6"
        rounded
      />
      <itemsAutocomplete class="mt-6 ml-4" v-if="type=='Producto'" @selectedItem="selectedItem" style="width:400px;"/>
      <v-switch
        class="ml-4 mt-7"
        label="Solo Productos Publicados"
        v-model="is_published"
      />
      <v-spacer/>
      <div :style="type=='Producto'?'padding: 30px 0px;':''">
        <span>Total seleccionado</span>
        <strong>{{ formatMoney(selectedShoppingTotal) }}</strong>
      </div>
    </v-row>

    <v-data-table
      height="calc(100vh - 300px)"
      fixed-header
      v-model="selected"
      :headers="headers"
      :items="visibleProducts"
      :loading="loading"
      item-key="id"
      show-select
      :options.sync="options"
      :server-items-length="tableItemsLength"
      hide-default-footer
      :footer-props="{
        'items-per-page-options': itemsPerPageOptions,
        'items-per-page-text': 'Items por página'
      }"
      :item-class="itemRowBackground" 
    >
      <template #item.latest_shopping_id="{ item }">
        <v-list-item
          class="px-0"
          style="min-height:0!important; font-size:14px;"
          :to="{ path: '/shoppings/' + item.latest_shopping_id }"
        >
          {{ (item.latest_shopping_id || '') + ' | ' + (item.latest_provider || '') + ' | ' + (item.latest_shopping_date || '')}}
        </v-list-item>
      </template>

      <template #item.current_inventory="{ item }">
        <v-list-item
          class="px-0"
          style="min-height:0!important; font-size:14px;"
          :to="{ path: '/inventory-reports/' + item.id }"
        >
          {{ item.current_inventory }}
        </v-list-item>
      </template>

      <template #item.latest_cost="{ item }">
        <v-list-item
          class="px-0"
          style="min-height:0!important; font-size:14px;"
        >
          {{ (item.latest_cost * 1).toLocaleString('es-MX', {
               style: 'currency',
               currency: 'MXN'
             })
          }}
        </v-list-item>
      </template>

      <template #item.latest_quantity="{ item }">
        {{ item.latest_quantity }}
      </template>

      <!-- Slot de sugerencia de compra -->
      <template #item.sugested_shopping="{ item }">
        <v-text-field
          hide-details
          class="inputperron"
          outlined dense
          :value="item.to_shop"
          @input="updateToShop(item.id, $event)"
          :filled="item.sugested_shopping!=item.to_shop"
        />
      </template>
    </v-data-table>

    <div v-if="hasMoreProducts" class="shopping-report-load-more">
      <span>
        Mostrando {{ visibleProducts.length }} de {{ sortedProducts.length }} producto(s)
      </span>
      <v-btn small outlined color="primary" @click="showMoreProducts()">
        Mostrar 250 más
      </v-btn>
    </div>

    <!-- DIALOG PARA IMPRIMIR -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card ref="printCard" class="print-section">
        <v-card-title class="headline" style="margin:30px 0px!important;">
          {{ providerName(provider_id) }}
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Código</th>
                <th>Producto</th>
                <th>Sugerencia de Compra</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in printItems" :key="item.id">
                <td>{{ item.code_one }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.sugested_shopping }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn text color="primary" @click="printDialog()">Imprimir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createDialog" max-width="95vw">
      <create
        :prefill="shoppingPrefill"
        @closeDialogCreateShopping="closeDialogCreateShopping"
      />
    </v-dialog>

    <v-dialog v-model="saveSelectionDialog" max-width="500px">
      <v-card class="pa-2">
        <v-card-title>Preguardar selección</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="saveSelectionLabel"
            label="Etiqueta"
            outlined
            dense
            autofocus
            @keydown.enter="saveCurrentSelection()"
          ></v-text-field>
          <div class="grey--text text--darken-1">
            {{ selected.length }} producto(s) | {{ type }} | {{ providerName(provider_id) || 'Sin proveedor' }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="saveSelectionDialog = false">Cancelar</v-btn>
          <v-btn color="primary" text :disabled="!saveSelectionLabel.trim()" @click="saveCurrentSelection()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color">
      {{ snackbar.message }}
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import XLSX from 'xlsx';
import itemsAutocomplete from "../inventory/helpers/items_autocomplete.vue"
import Create from "../shoppings/create"

export default {
  components: {
      'itemsAutocomplete':itemsAutocomplete,
      'create':Create,
  },
  data() {
    return {
      type:'Producto',
      selected: [],
      loading: false,
      provider_id: null,
      item_id:null,
      is_published: true,
      products: [],
      totalItems: 0,
      visibleLimit: 250,

      options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['sugested_shopping'],
        sortDesc: []
      },

      headers: [
        { text: 'Código', value: 'code' },
        { text: 'Producto', value: 'name' },
        { text: 'Ventas Trimestre', value: 'last_quarter_quantity' },
        { text: 'Promedio Ventas Trimestre', value: 'last_quarter_quantity_avg' },
        { text: 'Inventario', value: 'current_inventory', sortable: true },
        { text: 'Sugerencia de Compra (base trimestre)', value: 'sugested_shopping' },
        { text: 'Ventas Últimos 30 Días', value: 'last_thirty_days_quantity' },
        { text: 'Última Compra', value: 'latest_shopping_id', sortable: false },
        { text: 'Última cantidad', value: 'latest_quantity' },
        { text: 'Último costo', value: 'latest_cost' },
      ],

      dialog: false,
      createDialog: false,
      shoppingPrefill: null,
      requestId: 0,
      cancelFetchData: null,
      saveSelectionDialog: false,
      saveSelectionLabel: '',
      savedSelections: [],
      draftAvailable: false,
      syncingSelection: false,
      draftPersistTimer: null,
      snackbar: {
        show: false,
        message: '',
        color: 'success',
      },
    };
  },
  computed: {
    presaved(){
      return this.savedSelections;
    },
    providers() {
      return this.$store.state.provider.providers;
    },
    displayProducts() {
      return this.products;
    },
    tableItemsLength() {
      return Math.max(this.totalItems, this.products.length);
    },
    itemsPerPageOptions() {
      return [-1];
    },
    selectedShoppingTotal() {
      return this.selectedInTableOrder.reduce((total, item) => {
        const quantity = Number(item.to_shop ?? item.sugested_shopping ?? 0);
        const cost = Number(item.latest_cost ?? 0);
        return total + (quantity * cost);
      }, 0);
    },
    visibleProducts() {
      return this.sortedProducts.slice(0, this.visibleLimit);
    },
    hasMoreProducts() {
      return this.visibleProducts.length < this.sortedProducts.length;
    },
    sortedProducts() {
      const { sortBy, sortDesc } = this.options;
      const source = this.displayProducts;
      if (sortBy[0] === 'current_inventory') {
        return source;
      }
      if (!sortBy.length) return source;
      const key = sortBy[0];
      const desc = sortDesc[0];
      return [...source].sort((a, b) => {
        const va = isNaN(a[key]) ? a[key] : parseFloat(a[key]);
        const vb = isNaN(b[key]) ? b[key] : parseFloat(b[key]);
        if (va < vb) return desc ? 1 : -1;
        if (va > vb) return desc ? -1 : 1;
        return 0;
      });
    },
    selectedInTableOrder() {
      const selectedMap = new Map(
        this.selected.map(item => [String(item.id), this.normalizeProductRow(item)])
      );
      const ordered = this.sortedProducts
        .filter(item => selectedMap.has(String(item.id)))
        .map(item => ({
          ...item,
          ...selectedMap.get(String(item.id)),
        }));
      const orderedIds = new Set(ordered.map(item => String(item.id)));
      const missing = this.selected
        .filter(item => !orderedIds.has(String(item.id)))
        .map(item => this.normalizeProductRow(item));

      return ordered.concat(missing);
    },
    printItems() {
      return this.selectedInTableOrder
        .map(item => ({
          id: item.id,
          name: item.name,
          sugested_shopping: item.to_shop,
          code_one: item.code_one
        }));
    }
  },
  watch: {
    type() {
      this.resetQueryState();
      this.persistDraft();
    },
    provider_id() {
      if (this.type !== 'Proveedor') {
        this.persistDraft();
        return;
      }
      this.item_id = null;
      this.visibleLimit = 250;
      this.options.page = 1;
      this.fetchData();
      this.persistDraft();
    },
    item_id() {
      if (this.type === 'Producto') {
        this.visibleLimit = 250;
        this.options.page = 1;
        this.fetchData();
      }
      this.persistDraft();
    },
    is_published() {
      this.options.page = 1;
      this.visibleLimit = 250;
      this.fetchData();
      this.persistDraft();
    },
    'options.page'() { this.fetchData(); },
    'options.itemsPerPage'() {
      this.options.page = 1;
      this.fetchData();
    },
    'options.sortBy'(val) {
      this.visibleLimit = 250;
      if (val[0] === 'current_inventory') { this.options.page = 1; this.fetchData(); }
    },
    'options.sortDesc'() {
      this.visibleLimit = 250;
      if (this.options.sortBy[0] === 'current_inventory') { this.fetchData(); }
    },
    selected: {
      handler() {
        if (this.syncingSelection) {
          return;
        }
        this.queuePersistDraft();
      },
    },
  },
  mounted() {
    this.loadSavedSelections();
    if (!this.restoreDraftSelection()) {
      this.fetchData();
    }
    window.addEventListener('focus', this.handleWindowFocus);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    window.removeEventListener('focus', this.handleWindowFocus);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    if (this.draftPersistTimer) {
      clearTimeout(this.draftPersistTimer);
      this.persistDraft();
    }
    this.cancelCurrentFetch();
  },
  methods: {
    cancelCurrentFetch() {
      if (this.cancelFetchData) {
        this.cancelFetchData('Nueva búsqueda en reporte de compras.');
        this.cancelFetchData = null;
      }
    },
    savedDraftKey() {
      return 'shopping-report-draft-v1';
    },
    savedSelectionsKey() {
      return 'shopping-report-presaved-v1';
    },
    syncSelected(items) {
      const selectedIds = new Set(this.selected.map(item => String(item.id)));
      const nextSelected = items.filter(item => selectedIds.has(String(item.id)));
      this.syncingSelection = true;
      this.selected = nextSelected;
      this.$nextTick(() => {
        this.syncingSelection = false;
      });
    },
    formatMetric(value) {
      return (Number(value || 0) * 1).toFixed(2);
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
      });
    },
    normalizeProductRow(item) {
      return {
        id: item.id,
        name: item.name,
        is_published: item.is_published,
        last_quarter_quantity: this.formatMetric(item.last_quarter_quantity),
        last_quarter_quantity_avg: this.formatMetric(item.last_quarter_quantity_avg),
        current_inventory: this.formatMetric(item.current_inventory),
        sugested_shopping: this.formatMetric(item.sugested_shopping),
        to_shop: item.to_shop ?? this.formatMetric(item.sugested_shopping),
        last_thirty_days_quantity: this.formatMetric(item.last_thirty_days_quantity),
        latest_shopping_id: item.latest_shopping_id,
        latest_provider: item.latest_provider,
        latest_provider_id: item.latest_provider_id,
        latest_shopping_date: item.latest_shopping_date,
        latest_quantity: this.formatMetric(item.latest_quantity),
        latest_cost: Number(item.latest_cost ?? 0),
        code: item.code || item.code_one || item.code_two || item.code_three || '',
        code_one: item.code_one || item.code || item.code_two || item.code_three || '',
      };
    },
    mapApiItems(items) {
      return (items || []).map(item => this.normalizeProductRow({
        id: item.id,
        name: item.name,
        is_published: item.is_published,
        last_quarter_quantity: item.last_quarter_quantity,
        last_quarter_quantity_avg: (item.last_quarter_quantity / 3),
        current_inventory: item.current_inventory,
        sugested_shopping: ((item.last_quarter_quantity / 3) - (item.current_inventory * 1)) < 0
          ? 0
          : ((item.last_quarter_quantity / 3) - (item.current_inventory * 1)),
        to_shop: ((item.last_quarter_quantity / 3) - (item.current_inventory * 1)) < 0
          ? 0
          : ((item.last_quarter_quantity / 3) - (item.current_inventory * 1)),
        last_thirty_days_quantity: item.last_thirty_days_quantity,
        latest_shopping_id: item.latest_shopping_id,
        latest_provider: item.latest_provider_name,
        latest_provider_id: item.latest_provider_id,
        latest_shopping_date: item.latest_shopping_date,
        latest_quantity: item.latest_quantity,
        latest_cost: item.latest_cost ?? 0,
        code: item.code_one || item.code_two || item.code_three || '',
        code_one: item.code_one || item.code_two || item.code_three || '',
      }));
    },
    mergeSelectedWithProducts(products) {
      const merged = new Map();
      const selectedMap = new Map(
        this.selected.map(item => [String(item.id), this.normalizeProductRow(item)])
      );

      (products || []).forEach(item => {
        const normalized = this.normalizeProductRow(item);
        const existing = selectedMap.get(String(normalized.id));
        merged.set(String(normalized.id), existing ? {
          ...normalized,
          to_shop: existing.to_shop ?? normalized.to_shop,
        } : normalized);
      });

      selectedMap.forEach((item, id) => {
        if (!merged.has(id)) {
          merged.set(id, item);
        }
      });

      return Array.from(merged.values());
    },
    serializeSelection() {
      return this.selectedInTableOrder.map(item => this.normalizeProductRow(item));
    },
    buildSelectionSnapshot(label = '') {
      return {
        id: Date.now().toString(),
        label,
        type: this.type,
        provider_id: this.provider_id,
        provider_name: this.providerName(this.provider_id),
        item_id: this.item_id,
        is_published: this.is_published,
        options: {
          sortBy: [...(this.options.sortBy || [])],
          sortDesc: [...(this.options.sortDesc || [])],
        },
        selected: this.serializeSelection(),
        updated_at: new Date().toISOString(),
      };
    },
    persistDraft() {
      const snapshot = {
        type: this.type,
        provider_id: this.provider_id,
        item_id: this.item_id,
        is_published: this.is_published,
        options: {
          sortBy: [...(this.options.sortBy || [])],
          sortDesc: [...(this.options.sortDesc || [])],
        },
        selected: this.serializeSelection(),
        updated_at: new Date().toISOString(),
      };
      try {
        localStorage.setItem(this.savedDraftKey(), JSON.stringify(snapshot));
        this.draftAvailable = true;
      } catch (error) {
        this.draftAvailable = false;
      }
    },
    queuePersistDraft() {
      if (this.draftPersistTimer) {
        clearTimeout(this.draftPersistTimer);
      }
      this.draftPersistTimer = setTimeout(() => {
        this.persistDraft();
        this.draftPersistTimer = null;
      }, 300);
    },
    restoreDraftSelection() {
      try {
        const raw = localStorage.getItem(this.savedDraftKey());
        this.draftAvailable = !!raw;
        if (!raw) {
          return false;
        }
        const snapshot = JSON.parse(raw);
        this.applySelectionSnapshot(snapshot);
        return true;
      } catch (error) {
        this.draftAvailable = false;
        return false;
      }
    },
    clearCurrentSelection() {
      this.syncingSelection = true;
      this.selected = [];
      this.$nextTick(() => {
        this.syncingSelection = false;
      });
      this.products = [];
      this.totalItems = 0;
      this.item_id = null;
      this.persistDraft();
      if (this.type === 'Proveedor' && this.provider_id) {
        this.fetchData();
      }
    },
    loadSavedSelections() {
      try {
        const raw = localStorage.getItem(this.savedSelectionsKey());
        this.savedSelections = raw ? JSON.parse(raw) : [];
      } catch (error) {
        this.savedSelections = [];
      }
    },
    persistSavedSelections() {
      localStorage.setItem(this.savedSelectionsKey(), JSON.stringify(this.savedSelections));
    },
    openSaveSelectionDialog() {
      this.saveSelectionLabel = `${this.type} ${new Date().toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).toString().slice(0, 16)}`;
      this.saveSelectionDialog = true;
    },
    saveCurrentSelection() {
      const label = this.saveSelectionLabel.trim();
      if (!label) {
        return;
      }
      const snapshot = this.buildSelectionSnapshot(label);
      this.savedSelections = [snapshot].concat(this.savedSelections.filter(saved => saved.label !== label));
      this.persistSavedSelections();
      this.saveSelectionDialog = false;
      this.saveSelectionLabel = '';
      this.snackbar = {
        show: true,
        message: 'Selección guardada con éxito.',
        color: 'success',
      };
    },
    selectionSummary(saved) {
      const count = saved.selected?.length || 0;
      return `${saved.type || 'Selección'} | ${saved.provider_name || 'Sin proveedor'} | ${count} producto(s)`;
    },
    deleteSavedSelection(id) {
      this.savedSelections = this.savedSelections.filter(saved => saved.id !== id);
      this.persistSavedSelections();
    },
    applySelectionSnapshot(snapshot) {
      this.type = snapshot.type || 'Producto';
      this.provider_id = snapshot.provider_id ?? null;
      this.item_id = snapshot.item_id ?? null;
      this.is_published = snapshot.is_published !== false;
      this.options = {
        ...this.options,
        page: 1,
        sortBy: snapshot.options?.sortBy || this.options.sortBy,
        sortDesc: snapshot.options?.sortDesc || this.options.sortDesc,
      };
      const selected = (snapshot.selected || []).map(item => this.normalizeProductRow(item));
      this.syncingSelection = true;
      this.selected = selected;
      this.$nextTick(() => {
        this.syncingSelection = false;
      });
      this.fetchData();
    },
    loadSavedSelection(id) {
      const saved = this.savedSelections.find(item => item.id === id);
      if (!saved) {
        return;
      }
      this.applySelectionSnapshot(saved);
    },
    updateToShop(id, value) {
      const normalizedValue = value;
      const productIndex = this.products.findIndex(item => String(item.id) === String(id));
      if (productIndex !== -1) {
        this.products[productIndex].to_shop = normalizedValue;
      }
      const selectedIndex = this.selected.findIndex(item => String(item.id) === String(id));
      if (selectedIndex !== -1) {
        this.selected[selectedIndex].to_shop = normalizedValue;
      }
      this.queuePersistDraft();
    },
    showMoreProducts() {
      this.visibleLimit += 250;
    },
    itemRowBackground: function (item) {
      if(item.last_quarter_quantity_avg<item.last_thirty_days_quantity){
        return 'background-red'
      }
    },
    resetQueryState() {
      this.products = [];
      this.totalItems = 0;
      this.visibleLimit = 250;
      this.options = {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['sugested_shopping'],
        sortDesc: []
      };
      if (this.type === 'Proveedor') {
        this.item_id = null;
        this.fetchData();
        return;
      }
      this.item_id = null;
    },
    selectedItem: function(product) {
      const nextItemId = product?.id ?? null;
      this.options.page = 1;
      if (this.item_id === nextItemId) {
        this.fetchData();
        return;
      }
      this.item_id = nextItemId;
    },
    hasSearchContext() {
      if (this.type === 'Proveedor') {
        return this.provider_id != null && this.provider_id !== '';
      }
      return this.item_id != null && this.item_id !== '';
    },
    handleWindowFocus() {
      if (this.hasSearchContext()) {
        this.fetchData();
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && this.hasSearchContext()) {
        this.fetchData();
      }
    },
    fetchData() {
      const needsProviderFilter = this.type === 'Proveedor';
      const needsItemFilter = this.type === 'Producto';
      const hasProvider = this.provider_id != null && this.provider_id !== '';
      const hasItem = this.item_id != null && this.item_id !== '';

      if ((needsProviderFilter && !hasProvider) || (needsItemFilter && !hasItem)) {
        this.cancelCurrentFetch();
        this.products = [];
        this.totalItems = this.selected.length;
        this.loading = false;
        return;
      }
      this.cancelCurrentFetch();
      this.loading = true;
      const currentRequest = ++this.requestId;
      const cancelSource = axios.CancelToken.source();
      this.cancelFetchData = cancelSource.cancel;
      const params = {
        page: this.options.page,
        itemsPerPage: this.resolveItemsPerPage(),
      };
      if (needsProviderFilter && hasProvider) {
        params['filter[latest_provider_id]'] = this.provider_id;
      }
      if (needsItemFilter && hasItem) {
        params['filter[item_id]'] = this.item_id;
      }
      if (this.is_published) {
        params['filter[is_published]'] = 1;
      }
      if (this.options.sortBy[0] === 'current_inventory') {
        const prefix = this.options.sortDesc[0] ? '-' : '';
        params.sort = prefix + 'current_inventory';
      }
      axios
        .get(`${process.env.VUE_APP_BACKEND_ROUTE}api/v2/shopping_item_report`, {
          params,
          cancelToken: cancelSource.token,
        })
        .then(({ data }) => {
          if (currentRequest !== this.requestId) return;
          const mappedProducts = this.mapApiItems(data.data || []);
          this.products = this.mergeSelectedWithProducts(mappedProducts);
          this.totalItems = data.meta?.total ?? data.total ?? 0;
          if(this.totalItems>0&&this.totalItems<2){
            const mergedSelection = new Map(this.selected.map(item => [String(item.id), this.normalizeProductRow(item)]));
            mappedProducts.forEach(item => {
              const existing = mergedSelection.get(String(item.id));
              mergedSelection.set(String(item.id), existing ? {
                ...item,
                to_shop: existing.to_shop ?? item.to_shop,
              } : item);
            });
            this.syncingSelection = true;
            this.selected = Array.from(mergedSelection.values());
            this.$nextTick(() => {
              this.syncingSelection = false;
            });
          }
          this.syncSelected(this.products);
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            return;
          }
          this.snackbar = {
            show: true,
            message: error.response?.data?.message || 'Error al cargar el reporte de compras.',
            color: 'error',
          };
        })
        .finally(() => {
          if (currentRequest === this.requestId) {
            this.loading = false;
            this.cancelFetchData = null;
          }
        });
    },
    resolveItemsPerPage() {
      return this.options.itemsPerPage === -1 ? 50000 : this.options.itemsPerPage;
    },
    providerName(id) {
      const prov = this.providers.find(p => String(p.id) === String(id));
      return prov ? prov.name : '';
    },
    openPDF() {
      this.dialog = true;
    },
    exportInternalExcel() {
      const data = this.selectedInTableOrder.map(item => ({
        'Código': item.code,
        'Producto': item.name,
        'Ventas Trimestre': item.last_quarter_quantity,
        'Promedio Ventas Trimestre': item.last_quarter_quantity_avg,
        'Inventario': item.current_inventory,
        'Sugerencia de Compra (base trimestre)': item.to_shop ?? item.sugested_shopping,
        'Ventas Últimos 30 Días': item.last_thirty_days_quantity,
        'Última Compra': item.latest_shopping_id,
        'Último Proveedor': item.latest_provider,
        'Fecha Última Compra': item.latest_shopping_date,
        'Última cantidad': item.latest_quantity,
        'Último costo': item.latest_cost,
      }));
      const sheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, 'Reporte');
      const provider = this.providerName(this.provider_id) || 'proveedor';
      const safeProvider = provider.replace(/[\\/:*?"<>|]/g, '').slice(0, 60);
      XLSX.writeFile(workbook, `reporte_compras_interno_${safeProvider}.xlsx`);
    },
    openCreateShopping() {
      const today = new Date()
        .toLocaleString("sv-SE", { timeZone: "America/Monterrey" })
        .toString()
        .slice(0, 10);
      this.shoppingPrefill = {
        provider_id: this.provider_id,
        date: today,
        products: this.selectedInTableOrder.map((item) => ({
          shopping_id: "",
          item_id: JSON.stringify({ id: item.id, name: item.name }),
          quantity: item.to_shop ?? item.sugested_shopping ?? 0,
          unit_cost: "",
          created_by_user_id: "",
          last_updated_by_user_id: "",
          discount: "",
          original_cost: item.latest_cost ?? 0,
        })),
      };
      this.createDialog = true;
    },
    closeDialogCreateShopping() {
      this.createDialog = false;
      this.shoppingPrefill = null;
    },
    compareProductCodes(a, b) {
      const codeA = String(a || '').trim();
      const codeB = String(b || '').trim();
      const numberA = Number(codeA);
      const numberB = Number(codeB);

      if (codeA !== '' && codeB !== '' && !Number.isNaN(numberA) && !Number.isNaN(numberB)) {
        return numberA - numberB;
      }

      return codeA.localeCompare(codeB, 'es', { numeric: true, sensitivity: 'base' });
    },
    printDialog() {
         // Toma el HTML ya renderizado del diálogo
         const html = this.$refs.printCard.$el.outerHTML;
    
         // Crea una nueva ventana
         const printWindow = window.open('', '_blank', 'width=800,height=600');
         printWindow.document.write(`
           <html>
             <head>
               <title>Reporte de Compras</title>
               <style>
                 /* Ajustes simples para que se vea bien */
                 body { font-family: sans-serif; margin: 20px; }
                 table { width: 100%; border-collapse: collapse; }
                 th, td { border: 1px solid #666; padding: 8px; text-align: left; }
                 th { background: #eee; }
                 .v-card-actions, button, .v-btn { 
                   display: none !important; 
                 }
               </style>
             </head>
             <body>
               ${html}
             </body>
           </html>
         `);
         printWindow.document.close();
         printWindow.focus();
         // Espera un momento a que cargue
         setTimeout(() => {
           printWindow.print();
           printWindow.close();
         }, 300);
         this.dialog = false;
       }
    }
};
</script>

<style>
@media print {
  body * { visibility: hidden; }
  .v-dialog__content, .v-dialog__content * { visibility: visible; }
  .v-card { position: absolute; left: 0; top: 0; width: 100%; }
}
.inputperron input { padding: 0!important; }
.background-red{
  background-color: rgba(255, 0, 0, 0.169);
}
.shopping-report-totalizer{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: -8px;
  padding-right: 8px;
  font-size: 14px;
  color: #616161;
}
.shopping-report-totalizer strong{
  font-size: 18px;
  color: #212121;
}
.shopping-report-load-more{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  padding: 14px 8px 0;
  color: #616161;
  font-size: 13px;
}
</style>
